import styled from '@emotion/styled';
import { EmotionContainerViewProps } from './types';

export const SelectsWrapper = styled.div<EmotionContainerViewProps>`
  display: grid;
  grid-template-columns: 1fr 0.5fr 0.6fr;
  gap: ${({ halfWidth }) => (halfWidth ? '4px' : '10px')};

  @media only screen and (max-width: 1125px) {
    gap: 10px;
  }
`;
